import { React, useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContentText from '@mui/material/DialogContentText';
import { LocalStorage } from '../../store/local-storage';
import { environment } from '../../environments/environment';
import axios from '../../axios-interceptor';
import { toaster } from '../../components/common/Toaster';
import { checkIfServerError } from '../../actions/AuthActionsAPI';
import { useTranslation } from 'react-i18next';
export const deleteProfileAPI = (cb) => {
    const baseURL = environment.baseURL;
    const userId = localStorage.getItem('userId');
    axios
        .delete(`${baseURL}/security/account/${userId}`)
        ?.then((data) => {
            if (data.data.message == 'Delete user successful') {
                toaster(data.data.message, 'Info');
                LocalStorage.clearAuthCredentials();
                window?.location?.reload();
            }
            cb();
        })
        .catch((err) => {
            if (checkIfServerError) {
                toaster(err.message);
            }
            cb();
        });
};

export const handleConfirmClose = (setConfirmOpen,setDeleteOpen,componentProp) => {
    setConfirmOpen(false);
    setDeleteOpen(false);
    componentProp(false);
};

const DeleteProfileComponent = (props) => {
    const { componentProp } = props;
    const [deleteOpen, setDeleteOpen] = useState(true);
    const [confirmOpen, setConfirmOpen] = useState(false);
    const { t } = useTranslation();
    const handleDeleteClose = () => {
        componentProp(false);
    };


    const handleDelete = () => {
        setDeleteOpen(false);
        deleteProfileAPI(handleDeleteClose);
    };

    const handleConfirmDelete = () => {
        setConfirmOpen(true);
        setDeleteOpen(false);
    };

   

    return (
        <div data-testid="deleteprofileComponent" className="delete-profile-component">
            <Dialog open={deleteOpen} onClose={handleDeleteClose} maxWidth={false}>
                <DialogTitle>{t('translation:pages.user_account.delete_Account.deleteMyAccount')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{t('translation:pages.user_account.delete_Account.deleteConfirmation')}</DialogContentText>
                </DialogContent>
                <DialogActions className='wrapperCancelConfirm' data-testid='wrapper-cancel-confirm'>
                    <Button id='delete-Cancel' onClick={handleDeleteClose} data-testid='delete-cancel'>{t('translation:pages.user_account.delete_Account.cancelButton')}</Button>
                    <Button id='delete-Confirm' onClick={handleConfirmDelete} variant="contained" color="error" data-testid='delete-confirm'>
                    {t('translation:pages.user_account.delete_Account.deleteButton')}
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog open={confirmOpen} onClose={() => handleConfirmClose(setConfirmOpen,setDeleteOpen,componentProp)}>
                <DialogTitle>{t('translation:pages.user_account.delete_Account.areYouSure')}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{t('translation:pages.user_account.delete_Account.youAreAboutToDelete')}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id='delete-Yes' onClick={handleDelete} data-testid='delete-yes'>{t('translation:pages.user_account.delete_Account.yesButton')}</Button>
                    <Button id='delete-No' onClick={handleDeleteClose} data-testid='delete-no'>{t('translation:pages.user_account.delete_Account.noButton')}</Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default DeleteProfileComponent;
